import PatientCovenantService from '../services/patientCovenant.service';

const patientCovenant = {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    all(_, {patientId, calendarId}) {
      return PatientCovenantService.all(patientId, calendarId);
    },
    allPatients(_, patientId) {
      return PatientCovenantService.allPatients(patientId);
    },
    one(_, id) {
      return PatientCovenantService.one(id);
    },
    create(_, covenant) {
      return PatientCovenantService.create(covenant);
    },
    update(_, covenant) {
      return PatientCovenantService.update(covenant);
    },
    remove(_, id) {
      return PatientCovenantService.remove(id);
    },
  },

  getters: {},
};

export default patientCovenant;
